import React from 'react'
import { UserProvider } from '../auth'
import { InstitutionProvider } from '../auth/InstitutionContext'
import { SocketProvider } from '../context/socket'
import { AppContextProvider } from '../context/AppContext'
import { CustomTourProvider } from '../context/TourContext'

const AppProviders = ({ children }) => {
    return (
        <UserProvider>
            <CustomTourProvider>
                <InstitutionProvider>
                    <SocketProvider>
                        <AppContextProvider>{children}</AppContextProvider>
                    </SocketProvider>
                </InstitutionProvider>
            </CustomTourProvider>
        </UserProvider>
    )
}

export default AppProviders
